import React, {Dispatch, SetStateAction} from "react"
import Typography from "./Typography/Typography"

type Props = {
    errors?: Record<string, string>
    setErrors?: Dispatch<SetStateAction<Record<string, string>>>
    inputValue: string
    setInputValue: Dispatch<SetStateAction<string>>
    label: string
    icon?: React.ReactNode
    inputName:string
}
function InputWithLabelAndIcon({errors, setErrors, setInputValue, inputValue, label, icon, inputName}:Props) {
	return (
		<div style={{gap: "4px"}}
			className={`d-flex align-items-start justify-content-start ${errors?.[inputName] ? "text-danger" : ""} flex-column`}>
			<Typography style={{height: "20px", fontSize: "14px", lineHeight: "20px"}}
				variant="bodyLg">{label}</Typography>
			<div className={`height-cta-field ${errors?.[inputName] ? "danger" : ""} `}>
				<input placeholder="180"
					value={inputValue}
					onChange={e => {
						setErrors({})
						setInputValue(e.target.value)
					}} />
				{icon ? icon : null}
			</div>

		</div>
	)
}

export default InputWithLabelAndIcon
